<template>
  <div>
    <b-modal
        id="modal-delete-report"
        ref="modal-delete-report"
        footer-class="flex-nowrap"
        no-close-on-backdrop
        no-close-on-esc
        centered
    >
      <template #modal-header>
        <h3>{{ $t('modals.deleteReport.title') }}</h3>
      </template>

      <template #default>
        <div class="delete-icon text-center">
          <b-icon icon="exclamation-triangle-fill" variant="danger" class="mt-5 mb-4"></b-icon>
          <div class="mt-2 mb-4">{{ $t('modals.deleteReport.message') }}</div>
        </div>
      </template>

      <template #modal-footer>
        <b-button
            class="p-3 border-right-light-grey"
            block
            @click="cancelModal"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
            variant="primary"
            class="p-3"
            block
            @click="deleteReport"
        >
          {{ $t('modals.deleteReport.validate') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalDeleteReport',
  props: ['report'],
  mounted() {
    this.$refs['modal-delete-report'].show();
  },
  methods: {
    deleteReport() {
      this.$emit('delete-report');
    },
    cancelModal() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>

</style>
